import type {WorkforceDashboardDepartmentHealth} from '../../types/workforceDashboardTypes';

export const sortDepartmentHealthByRisk = (
  items: WorkforceDashboardDepartmentHealth[]
): WorkforceDashboardDepartmentHealth[] => {
  return [...items].sort((a, b) => {
    const scoreA = a.averageAlignmentScore;
    const scoreB = b.averageAlignmentScore;

    if (scoreA === null && scoreB === null) {
      return a.companyDepartmentName.localeCompare(b.companyDepartmentName);
    }
    if (scoreA === null) {
      return 1;
    }
    if (scoreB === null) {
      return -1;
    }
    if (scoreA !== scoreB) {
      return scoreA - scoreB;
    }
    if (b.gapCount !== a.gapCount) {
      return b.gapCount - a.gapCount;
    }

    return a.companyDepartmentName.localeCompare(b.companyDepartmentName);
  });
};
